import { memo } from 'react';
import { motion } from 'motion/react';
import styles from './WordAnimator.module.css';

export const WordAnimator = memo(
  ({
    text,
    initDelay = 0,
    className,
    duration = 4,
    delay = 0.06,
    isRepeat = true,
  }) => {
    if (!text) return null;
    const letters = text.split('');

    const letterVariants = {
      hidden: { rotateY: -90, opacity: 0 },
      visible: isRepeat
        ? {
            rotateY: [-90, 0, 0, 90],
            opacity: [0, 1, 1, 0],
          }
        : { rotateY: 0, opacity: 1 },
    };

    return (
      <div className={`${styles.lettersWrapper} ${className}`}>
        {letters.map((l, idx) => (
          <motion.span
            key={l + idx}
            className={styles.letter}
            variants={letterVariants}
            initial="hidden"
            animate="visible"
            transition={{
              rotateY: {
                duration,
                delay: delay * idx + initDelay,
                ease: 'easeOut',
                times: isRepeat ?? [0, 0.25, 0.75, 1],
                repeat: isRepeat ?? 1,
                repeatDelay: isRepeat ?? 0.5,
              },

              opacity: {
                duration: isRepeat ? duration : 0.1,
                delay: delay * idx + initDelay,
                ease: 'easeOut',
                times: isRepeat ?? [0, 0.1, 0.9, 1],
                repeat: isRepeat ?? 1,
                repeatDelay: isRepeat ?? 0.5,
              },
            }}
          >
            {l === ' ' ? '\u00A0' : l}
          </motion.span>
        ))}
      </div>
    );
  },
);
